import { Component } from '@angular/core';
import { GLOBAL } from 'src/app/services/global';

@Component({
  selector: "page-resumen",
  templateUrl: "./resumen.component.html",
  styleUrls: ['./resumen.component.css']
})

export class ResumenComponent {
  public generico = GLOBAL.generico;
  public propiedad;
  public propietarios;
  public representantes;
  public empresas;
  public arquitectos;
  public constructores;
  public constructora;
  public independiente;
  public antecedentes;
  public proyecto;
  public permisos;
  public caracteristica_proyecto;
  public recepcion;
  public ampliacion;
  public antecedentes_edif;
  public superficie;
  public unidades;
  public disposicion;
  public clasificacion;
  public permisos_recep;
  public anteproy_condominio;
  public autorizaciones;
  public checkbox_checked = false;
  public n_form
  public tramite 



  constructor() {

    if (this.generico == true) {
      this.n_form = localStorage.getItem("formId");
      console.log('localStorage form', this.n_form)
      this.tramite = localStorage.getItem("formTitle");

    } else {
      console.log('localStorage form', localStorage.getItem("form"))
      this.n_form = localStorage.getItem("form");
    }

  }
  ngOnInit() {

  }



  ngAfterContentInit() {

    /*if(response.info.anteproy_condominio)
    localStorage.setItem("anteproy_condominio", JSON.stringify(response.info.anteproy_condominio));
    else localStorage.setItem("anteproy_condominio", JSON.stringify([]))
    
    if(response.info.autorizaciones)
    localStorage.setItem("autorizaciones", JSON.stringify(response.info.autorizaciones));
    else localStorage.setItem("autorizaciones", JSON.stringify([]))
    if(response.info.condiciones)
    localStorage.setItem("condiciones", JSON.stringify(response.info.condiciones));
    else localStorage.setItem("condiciones", JSON.stringify([]))
    if(response.info.disposiciones_esp)
    localStorage.setItem("disposiciones_esp", JSON.stringify(response.info.disposiciones_esp));
    else localStorage.setItem("disposiciones_esp", JSON.stringify([]))
    if(response.info.normas_urbanisticas)
    localStorage.setItem("normas_urbanisticas", JSON.stringify(response.info.normas_urbanisticas));
    else localStorage.setItem("normas_urbanisticas", JSON.stringify([]))
    if(response.info.permisos_recepciones)
    localStorage.setItem("permisos_recepciones", JSON.stringify(response.info.permisos_recepciones));
    else localStorage.setItem("permisos_recepciones", JSON.stringify([]))
    if(response.info.superficie_anteproyecto)
    localStorage.setItem("superficie_anteproyecto", JSON.stringify(response.info.superficie_anteproyecto));
    else localStorage.setItem("superficie_anteproyecto", JSON.stringify([]))
    if(response.info.uso_publico)
    localStorage.setItem("uso_publico", JSON.stringify(response.info.uso_publico));
    else localStorage.setItem("uso_publico", JSON.stringify([]))*/
    //PERMISOS RECEPCION
    if (localStorage.getItem("permisos_recep")) {
      if (JSON.parse(localStorage.getItem("permisos_recep")).length > 0) {
        this.permisos_recep = JSON.parse(localStorage.getItem("permisos_recep"))
      } else {
        localStorage.setItem("permisos_recep", JSON.stringify([]))
        //this.permisos_recep = [{tipo_permiso:'',permiso:'',numero:'',fecha:'',superficie:'',recepcion:'',fecha_recep:'' }]
      }
    }
    //PROPIEDAD
    if (localStorage.getItem("propiedad")) {
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }
    } else {
      localStorage.setItem("propiedad", JSON.stringify([]))
      // this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: '', direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
    }

    //PROPIETARIOS
    if (localStorage.getItem("propietarios")) {
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
      }
    } else {
      localStorage.setItem("propietarios", JSON.stringify([]))
      // this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
    }

    //REPRESENTANTE
    if (localStorage.getItem("representantes")) {
      if (JSON.parse(localStorage.getItem("representantes")).length > 0) {
        this.representantes = JSON.parse(localStorage.getItem("representantes")); //no es obligatorio pero si tiene informacion debe estar permiso_notariado obligatoriamente
      }
    } else {
      localStorage.setItem("representantes", JSON.stringify([]))
      // this.representantes = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
    }

    //ARQUITECTOS
    if (localStorage.getItem("arquitectos")) {
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }
    } else {
      localStorage.setItem("arquitectos", JSON.stringify([]))
      // this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
    }


    //EMPRESAS
    if (localStorage.getItem("empresas")) {
      if (JSON.parse(localStorage.getItem("empresas")).length > 0) {
        this.empresas = JSON.parse(localStorage.getItem("empresas"))
      }
    } else {
      localStorage.setItem("empresas", JSON.stringify([]))
      //this.empresas = [{rut: '',nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'', fax:'', mail:'', recordId:''}]
    }

    //CONSTRUCTORA
    if (localStorage.getItem("constructora")) {
      if (JSON.parse(localStorage.getItem("constructora")).length > 0) {
        this.constructora = JSON.parse(localStorage.getItem("constructora"))
      }
    } else {
      localStorage.setItem("constructora", JSON.stringify([]))
      //this.constructora = [{rut: '', nombre:'', direccion: '', direccion_num:'', direccion_complemento:'', direccion_completa:'', comuna:'', fono:'', fax:'', mail:'', patente:'', recordId:''}]
    }

    //CONSTRUCTORES 
    if (localStorage.getItem("constructores")) {
      if (JSON.parse(localStorage.getItem("constructores")).length > 0) {
        this.constructores = JSON.parse(localStorage.getItem("constructores"))
      }
    } else {
      localStorage.setItem("constructores", JSON.stringify([]))
      //  this.constructores = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'', patente:'', recordId:''}]
    }

    //INDEPENDIENTE
    if (localStorage.getItem("independiente")) {
      if (JSON.parse(localStorage.getItem("independiente")).length > 0) {
        this.independiente = JSON.parse(localStorage.getItem("independiente"))
      }
    } else {
      localStorage.setItem("independiente", JSON.stringify([]))
      // this.independiente = [{rut: '',nombre:'', apellido_mat:'',apellido_pat:'', direccion: '',direccion_num:'',direccion_complemento:'', direccion_completa:'', comuna:'',fono:'', fax:'',mail:'', patente:'', recordId:''}]  
    }

    //ANTECEDENTES
    if (localStorage.getItem("antecedentes")) {
      if (JSON.parse(localStorage.getItem("antecedentes")).length > 0) {
        this.antecedentes = JSON.parse(localStorage.getItem("antecedentes"))
      }
    } else {
      localStorage.setItem("antecedentes", JSON.stringify([]))
      //this.antecedentes = [{tipo_permiso:'',permiso:'',numero:'',fecha:'',superficie:''}] 
    }

    //PROYECTO
    if (localStorage.getItem("proyecto")) {
      if (JSON.parse(localStorage.getItem("proyecto")).length > 0) {
        this.proyecto = JSON.parse(localStorage.getItem("proyecto"))
      }
    } else {
      localStorage.setItem("proyecto", JSON.stringify([]))
      //this.proyecto = [{destinos:'', superf_existente:'',superf_proyectada:'',npisos:'',superf_terreno:'',coef_construct:'',ocupadooc:'',proyectadooc:'',autorizacion1:'',autorizacion2:'',autorizacion3:'',autorizacion4:'',autorizacion5:'',autorizacion6:'',uso_publico:'',edif_nac:''}] 
    }

    //PERMISOS
    if (localStorage.getItem("Permisos")) {
      if (JSON.parse(localStorage.getItem("Permisos")).length > 0) {
        this.permisos = JSON.parse(localStorage.getItem("Permisos"))
      }
    } else {
      localStorage.setItem("Permisos", JSON.stringify([]))
      // this.permisos = [{perm_numero:'', perm_fecha:'', superfm2:'', modproy:'', resolucion:'', fecha_resol:'', perm_prim:'', fecha_prim:'', recepcion:'', fecha_recep:'',recordId:'' }] 
    }

    //CARACTERISTICAS PROYECTO
    if (localStorage.getItem("caracteristica_proyecto")) {
      if (JSON.parse(localStorage.getItem("caracteristica_proyecto")).length > 0) {
        this.caracteristica_proyecto = JSON.parse(localStorage.getItem("caracteristica_proyecto"))
      }
    } else {
      localStorage.setItem("caracteristica_proyecto", JSON.stringify([]))
      //this.caracteristica_proyecto = [{destino:'', supertotal:'', modradio:'', usoradio:''}]
    }

    //AMPLIACION
    if (localStorage.getItem("ampliacion")) {
      if (JSON.parse(localStorage.getItem("ampliacion")).length > 0) {
        this.ampliacion = JSON.parse(localStorage.getItem("ampliacion"))
      }
    } else {
      localStorage.setItem("ampliacion", JSON.stringify([]))
      // this.ampliacion = [{sup_permiso:'',superf_terreno:'',piso1_ex:'',piso1_amp:'',piso2_ex:'',piso2_amp:'',piso3_ex:'',piso3_amp:'',superf_amp:'',condominio:'',economica:''}] 
    }

    //ANTECEDENTES EDIF
    if (localStorage.getItem("antecedentes_edif")) {
      if (JSON.parse(localStorage.getItem("antecedentes_edif")).length > 0) {
        this.antecedentes_edif = JSON.parse(localStorage.getItem("antecedentes_edif"))
      }
    } else {
      localStorage.setItem("antecedentes_edif", JSON.stringify([]))
      //this.antecedentes_edif = [{edificacion_antigua:'',ampliacion_antigua:'',destino:'',superf_total:'',superf_terreno:'',npisos:''}]
    }

    //SUPERFICIE
    if (localStorage.getItem("superficie")) {
      if (JSON.parse(localStorage.getItem("superficie")).length > 0) {
        this.superficie = JSON.parse(localStorage.getItem("superficie"))
      }
    } else {
      localStorage.setItem("superficie", JSON.stringify([]))
      // this.superficie = [{util1:'',comun1:'',total1:'',util2:'',comun2:'',total2:'',util3:'',comun3:'',total3:'',piso1:'',piso2:'',piso3:'',piso4:'',piso5:'',piso6:'',piso7:'',piso8:'',piso9:'',piso10:'',piso11:'',piso12:'',piso13:'',piso14:'',piso15:''}] 
    }
    //UNIDADES
    if (localStorage.getItem("unidades")) {
      if (JSON.parse(localStorage.getItem("unidades")).length > 0) {
        this.unidades = JSON.parse(localStorage.getItem("unidades"))
      }
    } else {
      localStorage.setItem("unidades", JSON.stringify([]))
      //  this.unidades = [{vivienda:'', oficinas:'', locales:'', estacionamientos:'', otros:''}]
    }



  }

  ver() {

    if (this.checkbox_checked) {
      localStorage.setItem("resumen", JSON.stringify(this.checkbox_checked))
    } else {
      localStorage.removeItem("resumen")
    }
  }
}